import React, { useState } from 'react';
import { SEO } from '../components/SEO';

export const ContactUs = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const subject = "Inquiry from Atelier Persopol Contact Form";
    const body = `Sender Email: ${email}\n\nMessage:\n${message}`;
    
    window.location.href = `mailto:yuyang.jiang@atelier-persopol.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    setSubmitted(true);
    setEmail('');
    setMessage('');
  };

  return (
    <div className="container mx-auto px-4 py-12 md:py-20">
      <SEO 
        title="Contact Us"
        description="Have a question? Contact Atelier Persopol for support, inquiries, or special requests regarding your custom AI art."
        url="https://www.atelier-persopol.com/contact-us"
      />
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-center mb-8">Contact Us</h1>
        <div className="text-center mb-12">
          <p className="text-gray-600 text-lg mb-4">
            Have a question or a special request? Send us a message and we'll get back to you as soon as possible.
          </p>
          <p className="text-gray-600 text-lg">
            Or email us directly at{' '}
            <a 
              href="mailto:yuyang.jiang@atelier-persopol.com" 
              className="text-black font-medium hover:underline transition-colors"
            >
              yuyang.jiang@atelier-persopol.com
            </a>
          </p>
        </div>

        {submitted ? (
          <div className="bg-green-50 border border-green-200 text-green-700 p-6 rounded-lg text-center">
            <h3 className="text-xl font-medium mb-2">Message Sent!</h3>
            <p>Thank you for reaching out. We've received your message and will be in touch shortly.</p>
            <button 
              onClick={() => setSubmitted(false)}
              className="mt-4 text-green-700 underline hover:text-green-800"
            >
              Send another message
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6 bg-white p-6 md:p-8 rounded-xl shadow-sm border border-gray-100">
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-black focus:border-transparent outline-none transition-all"
                placeholder="your@email.com"
              />
            </div>
            
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2">
                Your Request
              </label>
              <textarea
                id="message"
                required
                rows={6}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-black focus:border-transparent outline-none transition-all resize-none"
                placeholder="How can we help you?"
              />
            </div>

            <button
              type="submit"
              className="w-full bg-black text-white font-medium py-3 px-6 rounded-lg hover:bg-gray-800 transition-colors duration-200"
            >
              Send Message
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
